import { createContext, FC, useContext } from 'react'
import { useQuery } from 'react-query'
import { Shop } from '../../types'
import { logFactory } from '../../util/logFactory'
import { useAppointmentsService } from '../services'
import { useResolvedShopGid } from '../useResolvedShopGid'

interface ShopContext {
  shop?: Shop
  isError: boolean
  isLoading: boolean
}

const hookName = 'useShop'
const log = logFactory(hookName)

const context = createContext<ShopContext>({
  shop: undefined,
  isError: false,
  isLoading: true,
})

const { Provider } = context

const ShopProvider: FC = ({ children }) => {
  const { shopGid, isLoading: isResolvingShopGid } = useResolvedShopGid()
  const { getShops, isReady } = useAppointmentsService()

  const fetchShop = async (): Promise<Shop> => {
    const params = { gid: shopGid }

    log(`🏛️ Fetching shop...`, params)

    const { data: shops } = await getShops(params)
    const [found] = shops

    log(`🏛️ Found shop`, found)

    return found
  }

  const { data: shop, isError, isLoading } = useQuery([hookName, shopGid], fetchShop, { enabled: Boolean(shopGid && isReady) })

  return <Provider value={{ shop, isError, isLoading: (isResolvingShopGid || !isReady || isLoading) && !shop }}>{children}</Provider>
}

const useShop = (): ShopContext => useContext(context)

export { ShopProvider, useShop }
